import { render, staticRenderFns } from "./WorkOrderList.vue?vue&type=template&id=04ff4478&scoped=true"
import script from "./WorkOrderList.vue?vue&type=script&lang=js"
export * from "./WorkOrderList.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderList.vue?vue&type=style&index=0&id=04ff4478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff4478",
  null
  
)

export default component.exports